import {Link} from 'react-router-dom'
import {useLogout} from "../hooks/useLogout"
import { useAuthContext } from '../hooks/useAuthContext'

const Navbar= () => {

 const {logout} =useLogout()
 const {user} = useAuthContext()

 const handleClick = () => {
 logout()
 }

return (
<header>
<div className="container">
<Link to="/">
<h1>Matuckshop.com</h1>
</Link>
<nav>
{user && ( 
<div>
<span>{user.email}</span>
<Link to="/accountinfo">Acc info</Link>
<Link to="/earnmoney">Earnmoney</Link>
 <button onClick={handleClick}>Logout</button>   
</div>

)}
{!user && (
<div>
<Link to="/login">Login</Link>
<Link to="/signup">Signup</Link>
<Link to="/matuckshop">View tuckshops</Link>
</div>
)}
</nav>        
</div>
</header>
)
}

export default Navbar